/**
 * Accessibility Constants
 * Centralized constants for Accessibility reports
 */

// Accessibility Impact Levels
export const ACCESSIBILITY_IMPACT = {
  CRITICAL: 'critical',
  SERIOUS: 'serious',
  MODERATE: 'moderate',
  MINOR: 'minor'
}

// Accessibility Impact Colors (for badges)
export const ACCESSIBILITY_IMPACT_COLORS = {
  critical: 'red',
  serious: 'orange',
  moderate: 'yellow',
  minor: 'blue'
}

// Accessibility Impact Labels
export const ACCESSIBILITY_IMPACT_LABELS = {
  critical: 'Critical',
  serious: 'Serious',
  moderate: 'Moderate',
  minor: 'Minor'
}

// Accessibility Status
export const ACCESSIBILITY_STATUS = {
  OPEN: 'open',
  REOPENED: 'reopened',
  IN_PROGRESS: 'in_progress',
  BLOCKED: 'blocked',
  CLOSED: 'closed'
}

// Accessibility Status Colors (for badges)
export const ACCESSIBILITY_STATUS_COLORS = {
  open: 'blue',
  reopened: 'orange',
  in_progress: 'yellow',
  blocked: 'red',
  closed: 'green'
}

// Accessibility Status Labels
export const ACCESSIBILITY_STATUS_LABELS = {
  open: 'Open',
  reopened: 'Reopened',
  in_progress: 'In Progress',
  blocked: 'Blocked',
  closed: 'Closed'
}

// Status options for dropdowns
export const ACCESSIBILITY_STATUS_OPTIONS = [
  { label: 'Open', value: 'open' },
  { label: 'Reopened', value: 'reopened' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Blocked', value: 'blocked' },
  { label: 'Closed', value: 'closed' }
]

// Issue ID Tag Colors (array for variety)
export const ACCESSIBILITY_ISSUE_ID_COLORS = [
  'purple',
  'blue',
  'cyan',
  'teal',
  'green',
  'yellow',
  'orange',
  'red',
  'pink',
  'indigo'
]

/**
 * Generate a consistent color for an Issue ID based on its hash
 * @param issueId - The issue ID string
 * @returns A color from the ACCESSIBILITY_ISSUE_ID_COLORS array
 */
export const getIssueIdColor = (issueId: string): string => {
  // Simple hash function to convert string to number
  let hash = 0
  for (let i = 0; i < issueId.length; i++) {
    hash = ((hash << 5) - hash) + issueId.charCodeAt(i)
    hash = hash & hash // Convert to 32-bit integer
  }
  // Use absolute value and modulo to get index
  const index = Math.abs(hash) % ACCESSIBILITY_ISSUE_ID_COLORS.length
  return ACCESSIBILITY_ISSUE_ID_COLORS[index]
}

